import get from 'lodash.get';

const getPartnerDashboardUrl = (rootState) =>
  get(rootState, 'user.partnerData.properties.dashboardUrl', false);

export default getPartnerDashboardUrl;
